import React, { useContext, useEffect, useMemo } from "react";
import FormulaGenerator from "../../../FormulaGenerator";
import "./index.scss";
import { getStepInfo } from "../../stepInfo";
import { StepContext } from "../../StepContext";
import { useTranslation } from "../../../i18n";

const FixedProstheticsSelectAbutmentTooth = ({
  stepId,
  toggleNextBtnState
}) => {
  const {
    language
  } = useTranslation();
  const {
    isPatient,
    dentalData,
    setStepFormula
  } = useContext(StepContext);

  function setData(data) {
    setStepFormula(stepId, data);
    toggleNextBtnState(false);
  } // Disable next btn


  useEffect(() => {
    if (isPatient && (!dentalData || !dentalData.hasOwnProperty("tooth") || !dentalData.tooth.some(tooth => tooth.toothElementsActive.some(el => el === "plasticCrown")))) {
      toggleNextBtnState(true);
    } else {
      toggleNextBtnState(false);
    }
  }, [dentalData, toggleNextBtnState, isPatient]);
  const formulaHelperText = useMemo(() => {
    return getStepInfo(language, stepId)?.formulaHelperText || "";
  }, [language, stepId]);
  return /*#__PURE__*/React.createElement("div", {
    className: "fixedProstheticsSelectAbutmentTooth"
  }, /*#__PURE__*/React.createElement(FormulaGenerator, {
    projectData: dentalData,
    setProjectDentalData: setData,
    initialSelection: "fixedProstheticsSelectAbutmentTooth",
    availableSwitchers: ["top", "bottom", "base", "fixedProstheses"],
    formulaHelperText: formulaHelperText
  }));
};

export default FixedProstheticsSelectAbutmentTooth;